import React from 'react';
import { Helmet } from 'react-helmet';
import RegistrationGuide from '../Registration/subComponents/RegistrationGuide';
import './RegistrationGuidePage.scss';

const RegistrationGuidePage = () => (
    <div className="registration-guide-page">
        <Helmet>
            <meta charSet="utf-8" />
            <title>NFFS ICON - Registration Guide</title>
        </Helmet>

        <div className="guide-page-container">
            <RegistrationGuide />
        </div>
    </div>
);

export default RegistrationGuidePage; 


// WEBPACK FOOTER //
// ./src/pages/RegistrationGuide/RegistrationGuidePage.jsx